import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    padding: "20px 50px",
    fontFamily: "Open Sans",
  },

  textContent: {
    fontSize: 10,
    marginTop: 5,
    marginBottom: 5,
  },
});

const jsonView = {
  type: "page",
  items: [
    {
      type: "view",
      styles: {
        margin: 10,
        marginLeft: 20,
        padding: 10,
      },
      items: [
        {
          type: "text",
          styles: {
            fontSize: 11,
            marginTop: 15,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
            textTransform: "uppercase",
          },
          content: "Passenger list",
        },
      ],
    },

    {
      type: "view",
      attrs: { wrap: false },
      repeated: true,
      findRepeated: "passenger_firstname",
      styles: {
        //marginLeft: 20,
        paddingTop: 10,
        border: "1px solid #000",
        borderRadius: 4,
      },
      items: [
        {
          type: "text",
          dynamicIndexTitle: true,
          styles: {
            fontSize: 9,
            fontFamily: "Roboto-Bold",
          },
          content: "PASSENGER __index__",
        },
        {
          type: "view",
          styles: {
            paddingTop: 5,
            flexDirection: "row",
            justifyContent: "space-between",
          },
          items: [
            {
              type: "view",
              styles: { width: "40%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "FIRST NAME",
                },
                {
                  type: "text",
                  styles: { marginTop: 0, fontSize: 8 },
                  content: "__passenger_firstname__",
                  renderBlank: true,
                },
              ],
            },

            {
              type: "view",
              styles: { width: "40%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "LAST NAME",
                },
                {
                  type: "text",
                  styles: { marginTop: 0, fontSize: 8 },
                  content: "__passenger_surname__",
                  renderBlank: true,
                },
              ],
            },

            {
              type: "view",
              styles: { width: "20%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "NATIONALITY",
                },
                {
                  type: "text",
                  styles: { marginTop: 0, fontSize: 8 },
                  content: "__passenger_nationality__",
                  renderBlank: true,
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 0,
          },
          items: [
            {
              type: "view",
              styles: { width: "40%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "DATE OF BIRTH",
                },
                {
                  type: "text",
                  styles: { marginTop: 0, fontSize: 8 },
                  content: "__passenger_birthdate__",
                  renderBlank: true,
                },
              ],
            },

            {
              type: "view",
              styles: { width: "40%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "PLACE OF BIRTH",
                },
                {
                  type: "text",
                  styles: { marginTop: 0, fontSize: 8 },
                  content: "__passenger_birthplace__",
                  renderBlank: true,
                },
              ],
            },

            {
              type: "view",
              styles: { width: "20%" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "PASSPORT/ID",
                },
                {
                  type: "text",
                  styles: { marginTop: 0, fontSize: 8 },
                  content: "__passenger_passport__",
                  renderBlank: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default jsonView;
